// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import {
    AccountTilesApiParameter,
    AccountTilesDataModel,
    getAccountTilesData,
} from "@guestsupply/App/Services/AccountTilesService";
import { ApiHandler, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import logger from "@insite/client-framework/Logger";

type HandlerType = ApiHandler<AccountTilesApiParameter, AccountTilesDataModel>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = { ...props.parameter };
};

export const RequestDataFromApi: HandlerType = async props => {
    try {
        props.apiResult = await getAccountTilesData(props.apiParameter);
    } catch (error) {
        logger.error(error);
    }
};

export const DispatchCompleteLoadAccountTilesData: HandlerType = props => {
    props.dispatch({
        type: "xAccountTiles/CompleteLoadAccountTilesData",
        accountTilesData: props.apiResult,
    } as any);
};

export const chain = [PopulateApiParameter, RequestDataFromApi, DispatchCompleteLoadAccountTilesData];

const loadAccountTilesData = createHandlerChainRunner(chain, "loadAccountTilesData");

export default loadAccountTilesData;
